import withValidation from '../../../../shared/components/withValidation';
import ProvideDetailsForm from './ProvideDetailsForm';

const validate = ({ flyerTitle }) => flyerTitle === true;

const validateOnMount = (props, { isValid }) => isValid;

export default withValidation(ProvideDetailsForm, validate, validateOnMount);
